import { Component, OnDestroy, OnInit } from '@angular/core';
import { LmoDriver, LmoDriverService } from '~services/lmo-driver.service';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, pluck } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { BanDriverDialogComponent } from '../ban-driver-dialog/ban-driver-dialog.component';
import { FormControl } from '@angular/forms';
import { ReinstateDriverDialogComponent } from '../reinstate-driver-dialog/reinstate-driver-dialog.component';
import { UserService } from '~services/user.service';

@Component({
  selector: 'sa-lmo-driver-list',
  templateUrl: './lmo-driver-list.component.html',
  styleUrls: ['./lmo-driver-list.component.scss'],
})
export class LmoDriverListComponent implements OnInit, OnDestroy {
  public drivers$: Observable<LmoDriver[]>;
  public pageSize$: Observable<number>;
  public page$: Observable<number>;
  public total$: Observable<number>;

  public isNextierAccount: boolean;

  public driverSearchControl = new FormControl();

  private subs: Subscription[] = [];

  constructor(
    private lmoDriverService: LmoDriverService,
    public userService: UserService,
    private matDialog: MatDialog,
  ) {
    this.drivers$ = this.lmoDriverService.lmoDriversPage$.pipe(pluck('drivers'));
    this.pageSize$ = this.lmoDriverService.lmoDriversPage$.pipe(pluck('pageSize'));
    this.page$ = this.lmoDriverService.lmoDriversPage$.pipe(pluck('pageNumber'));
    this.total$ = this.lmoDriverService.lmoDriversPage$.pipe(pluck('total'));
    this.isNextierAccount = this.userService.isNexTierAccount();
  }

  public ngOnInit(): void {
    this.lmoDriverService.getLmoDrivers();

    if (this.lmoDriverService.searchbarValue$$.getValue().searchDriver) {
      this.driverSearchControl.patchValue(this.lmoDriverService.searchbarValue$$.getValue().searchDriver);
    }

    this.subs.push(
      this.driverSearchControl.valueChanges.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((search) => {
        this.lmoDriverService.setLmoDriversSearch(search);
        const currentSeachbarValue = this.lmoDriverService.searchbarValue$$.getValue();
        this.lmoDriverService.searchbarValue$$.next({
          ...currentSeachbarValue,
          searchDriver: search,
        });
      }),
    );
  }

  public ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  public sortChanged(sortParams) {
    if (sortParams.active && sortParams.direction) {
      this.lmoDriverService.setLmoDriversSort(sortParams.active, sortParams.direction);
    } else {
      this.lmoDriverService.setLmoDriversSort(null, null);
    }
  }

  public switchPage(page: PageEvent) {
    this.lmoDriverService.setLmoDriversPage(page.pageIndex + 1, page.pageSize);
  }

  public promptBanDriver(driver: LmoDriver) {
    this.matDialog.open(BanDriverDialogComponent, {
      data: { driver },
    });
  }
}
